import { VALIDATION_STATUS } from 'config/ui';
import pageActions from './actions';
import fieldActions from '../fields/actions';
import groupActions from '../groups/actions';
import plaidActions from '../plaid/actions';

export default (state = {}, action) => {
  switch (action.type) {
    case pageActions.GO_SUCCESS:
    case groupActions.UPLOAD_SUCCESS:
    case fieldActions.RERENDER_SUCCESS: {
      /** hack this is like this because of the kba page */
      if (!action.payload.data.meta.groups && !action.payload.data.meta.page) {
        return state;
      }
      const groups = Object.entries(action.payload.data.meta.groups || {}).map(
        ([, group]) => group,
      );
      const recaptchaEnabled = !!groups.find((g) => g.recaptchaEnabled) || false;
      return action.payload.data.meta.page
        ? { ...action.payload.data.meta.page, recaptchaEnabled }
        : { ...state, recaptchaEnabled };
    }
    case groupActions.NEXT_FAILED:
    case pageActions.NEXT_FAILED:
    case plaidActions.FETCH_ACCOUNTS_FAILED:
    case plaidActions.LINK_VERIFICATION_FAILED: {
      const { data } = action.payload;
      const response = data.result || data.meta;
      localStorage.removeItem('plaidLinkToken');
      if (response.msgs?.['*'] && !VALIDATION_STATUS[response.msgs['*']]) {
        return {
          ...state,
          error: true,
          errorFields: Object.keys(response?.msgs ?? {}).filter(
            (el) => el !== '*' && el !== 'appRequest_linkedPaymentCard_cardNetwork',
          ),
          errorMsg: response.msgs['*'],
        };
      }
      /** HACK: because we shouldn't be implementing recaptcha as a field but you know */
      // eslint-disable-next-line camelcase
      if (response.msgs?.appRequest_recaptcha) {
        return {
          ...state,
          error: true,
          errorMsg: response.msgs.appRequest_recaptcha,
        };
      }
      return state;
    }
    case pageActions.GO_FAILED: {
      const errorMsg =
        action.payload.data?.result?.msgs?.['*'] ??
        action.payload.data?.msg ??
        action.payload.data?.meta?.msgs?.['*'];

      return {
        error: true,
        errorMsg,
        name: 'error',
      };
    }
    case pageActions.NEXT:
    case groupActions.NEXT:
      return {
        ...state,
        error: false,
        errorMsg: '',
      };
    default:
      return state;
  }
};
